module.exports = __webpack_public_path__ + "static/media/cryptocurrency-hero 1.06f675e4.png";